export enum AddressRequestType {
  Planning = "PLANNING"
}
